// Mappers for Attendance Detail
import type {
  LC_GetAttendanceDetailOut,
  AttendanceDetail,
} from '../types';
import { formatToDdMmYyyy } from '@/utils';
import { normalizeMarkPhoto } from './markPhoto.mapper';


export function mapAttendanceDetailOutToModel(
  transport: LC_GetAttendanceDetailOut,
): AttendanceDetail {
  const { photoUrl, photoBase64 } = normalizeMarkPhoto(transport.photo);
  return {
    fecha: formatToDdMmYyyy(transport.date),
    hora: transport.hour ?? '',
    tipo: transport.type ?? '',
    evento: transport.eventName ?? '',
    deviceInformation: transport.deviceInformation ?? '',
    ubicacion: transport.ubicationName ?? '',
    photoBase64,
    photoUrl,
    latitude: transport.latitude ?? null,
    longitude: transport.longitude ?? null,
    mapUrl: transport.mapUrl ?? null,
  };
}
